import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./style.module.scss";

function InfoBannerSkeleton({ className }: { className?: string }) {
  return (
    <div className={classNames(styles.banner, className)}>
      <Skeleton
        variant="rounded"
        width={40}
        height={40}
        sx={{ borderRadius: "10px", flexShrink: 0 }}
      />
      <div className={styles.text} style={{ flex: 1 }}>
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="62%" height={20} />
      </div>
    </div>
  );
}

export default InfoBannerSkeleton;
